<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض القسم الفرعي</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>القسم الرئيسي</th>
                    <td>{{ subCategory.category.name }}</td>
                  </tr>
                  <tr>
                    <th>الإسم</th>
                    <td>{{ subCategory.name }}</td>
                  </tr>
                  <tr>
                    <th> الإسم بالعربي</th>
                    <td>{{ subCategory.name_ar }}</td>
                  </tr>
                  <tr>
                    <th>الوصف</th>
                    <td>{{ subCategory.description }}</td>
                  </tr>
                  <tr>
                    <th>الوصف بالعربي</th>
                    <td>{{ subCategory.description_ar }}</td>
                  </tr>
                </table>
            </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowSubCategory',
  data () {
    return {
      subCategory: []
    }
  },
  created () {
    console.log(this.$route.params.id)
    this.$http
      .get(`${this.$hostUrl}sub-categories/${this.$route.params.id}/edit`)
      .then((response) => {
        this.subCategory = response.data.data.subCategory
      })
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/sub-categories' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
